export default __webpack_public_path__ + "static/ZAK-2023-f2e2434247a3e3765f816bbeb6454616.png";